import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0 mb-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mr-4 my-2",
                density: "compact",
                variant: "text",
                onClick: _ctx.goToToday
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-calendar-import-outline")
                    ])),
                    _: 1,
                    __: [3]
                  }),
                  _cache[4] || (_cache[4] = _createTextVNode(" Hoy "))
                ]),
                _: 1,
                __: [4]
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                class: "pt-2 mx-1",
                icon: "",
                variant: "text",
                density: "compact",
                onClick: _ctx.goToPrevious
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-chevron-left")
                    ])),
                    _: 1,
                    __: [5]
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                class: "pt-2 mx-1",
                icon: "",
                variant: "text",
                density: "compact",
                onClick: _ctx.goToNext
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-chevron-right")
                    ])),
                    _: 1,
                    __: [6]
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.showMonthSelect)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    class: "month_select ml-2",
                    modelValue: _ctx.selectedMonth,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                    items: _ctx.months,
                    "item-title": "title",
                    "item-value": "value",
                    density: "compact",
                    variant: "solo",
                    "hide-details": "",
                    "max-width": "170"
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              (_ctx.showYearSelect)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 1,
                    class: "month_select",
                    modelValue: _ctx.selectedYear,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYear) = $event)),
                    items: _ctx.years,
                    density: "compact",
                    "hide-details": "",
                    "max-width": "120",
                    variant: "solo"
                  }, null, 8, ["modelValue", "items"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_menu, null, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    style: {"margin":"2px"},
                    class: "elevation-0"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-calendar-week")
                        ])),
                        _: 1,
                        __: [7]
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.calendarMode), 1)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarModes, (mode, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          disabled: "",
                          key: index,
                          onClick: ($event: any) => (_ctx.calendarMode = mode)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(mode), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeViewComponent), {
            "base-date": _ctx.baseDate,
            events: _ctx.mappedEvents,
            "calendar-config": _ctx.calendarConfig,
            "on-create": _ctx.openCreateForm,
            "on-view": _ctx.openDetailDrawer,
            title: _ctx.title,
            "module-name": _ctx.moduleName
          }, null, 40, ["base-date", "events", "calendar-config", "on-create", "on-view", "title", "module-name"]))
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        class: "float-drawer",
        modelValue: _ctx.drawerVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawerVisible) = $event)),
        location: "right",
        width: "500",
        temporary: ""
      }, {
        default: _withCtx(() => [
          (_ctx.drawerComponent)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.drawerComponent), {
                key: 0,
                id: _ctx.selectedEventId,
                onClose: _ctx.closeDialog
              }, null, 40, ["id", "onClose"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}